import React from "react";

/**
 * DiaModuleTypeProps
 */
interface DiaModuleTypeProps {
  config: any;
  I18N: any;
  showAll?: boolean
}

/**
 * ModuleTypes
 * @param config
 * @param showAll
 * @constructor
 */
export const ModuleTypes: React.FC<DiaModuleTypeProps> = ({
  config,
  I18N,
  showAll = false
}: DiaModuleTypeProps) => {
  /**
   * variables
   */
  let interlinkModuleTypes = JSON.parse(localStorage.getItem("dia:service:system:interlinkModulTypes") || "{}"),
    statusMapping = JSON.parse(localStorage.getItem("dia:service:system:partnerPartnerStatus") || "{}");

  const moduleTypesIcon = {
      'priceAndStock': 'money-check-dollar-pen',
      'productSearch': 'file-magnifying-glass',
      'bulkStockExport': 'boxes-stacked',
      'partnerFile': 'folder-open',
      'warmUpData': 'fire'
    },
    configKeys = Object.keys(config || {}),
    // with showAll every known module gets a badge, also the ones the config
    // carries no node for; the system enum sets the order, the icon mapping
    // only steps in when the enum is missing (not loaded yet), and unknown
    // config keys are appended so nothing silently disappears
    enumKeys = Object.values(interlinkModuleTypes).map((_type: any) => _type.id).filter((id: any) => !!id),
    baseKeys = enumKeys.length ? enumKeys : Object.keys(moduleTypesIcon),
    renderKeys: string[] = showAll
      ? baseKeys.concat(configKeys.filter((key) => !baseKeys.includes(key)))
      : configKeys;

  /**
   * render
   */
  return <dia-badge data-light>
    <ul>
      { renderKeys.map((key) => {
        let translateTypeObject = Object.values(interlinkModuleTypes).filter((_type: any) => _type.id === key),
          // @ts-ignore
          translatedType: string = translateTypeObject[0] ? translateTypeObject[0].description : key,
          // a generic icon keeps data-icon-before filled for modules the
          // mapping does not know yet
          // @ts-ignore
          moduleIcon: string = moduleTypesIcon[key] || 'cube',
          moduleData = (config ? config[key] : undefined) as { state: string } | undefined;

        if (moduleData && moduleData.state) {
          let translateStateObject = Object.values(statusMapping).filter((_state: any) => _state.id === moduleData.state),
            // the client overview fabricates the state id "active" (the config
            // carries a boolean, not an enum value); when the enum misses it,
            // fall back to the wording the enum entry would carry instead of
            // leaking the raw id
            stateFallbacks = { active: "aktiv" },
            // @ts-ignore
            translatedState: string = translateStateObject[0] ? translateStateObject[0].description : (stateFallbacks[moduleData.state] || moduleData.state),
            // the backend enum descriptions carry a stray degree sign ("aktiv°");
            // stripped here so tooltip and aria-label read clean text
            stateText = I18N.t(String(translatedState).replace(/°/g, "").trim());

          return (
            <li
              key={ key }
              data-icon-only
              // the aria-label names module and state for readers; no tabindex,
              // ten rows of badges would flood the tab order with stops that
              // hold no action
              role="img"
              aria-label={ `${translatedType}: ${stateText}` }
            >
              <i data-icon-before={ moduleIcon } aria-hidden="true"></i>
              <dia-tooltip
                data-hover
                data-nested
              >
                <ul>
                  <li data-no-hover>
                    <span>{ translatedType }</span>
                    <strong>{ stateText }</strong>
                  </li>
                </ul>
              </dia-tooltip>
            </li>
          );
        }

        let disabledStateText = I18N.t("Nicht verfügbar");

        return (
          <li
            key={ key }
            data-icon-only
            data-disabled
            role="img"
            aria-label={ `${translatedType}: ${disabledStateText}` }
          >
            <i data-icon-before={ moduleIcon } aria-hidden="true"></i>
            <dia-tooltip
              data-hover
              data-nested
            >
              <ul>
                <li data-no-hover><span>{translatedType}</span><strong>{ disabledStateText }</strong></li>
              </ul>
            </dia-tooltip>
          </li>
        );
      }) }
    </ul>
  </dia-badge>;
}
